import '../sass/language-selector.scss';

(() => {
    const $templateParts = document.querySelectorAll('.language-selector');

    if (!$templateParts) return;

    $templateParts.forEach($templatePart => {
        const $select = $templatePart.querySelector('.language-selector__select');
        const $current = $templatePart.querySelector('.language-selector__current');
        const $currentLabel = $templatePart.querySelector('.language-selector__current-label');

        const openSelect = () => {
            $templatePart.classList.add('language-selector--active');
            $current.setAttribute('aria-expanded', 'true');
        };

        const closeSelect = () => {
            $templatePart.classList.remove('language-selector--active');
            $current.setAttribute('aria-expanded', 'false');
        };

        const initDropdown = () => {
            if (!$templatePart || !$current) return;

            const $glinks = $templatePart.querySelectorAll('.glink');

            $current.addEventListener('click', () => {
                openSelect();
            });

            if ($glinks) {
                $glinks.forEach($glink => {
                    $glink.addEventListener('click', () => {
                        $currentLabel.textContent = $glink.textContent;
                        closeSelect();
                    });
                });
            }
        };

        document.addEventListener('DOMContentLoaded', () => {
            initDropdown();
        });

        window.addEventListener('click', e => {
            if ($templatePart.contains(e.target)) return;

            closeSelect();
        });
    });
})();
